<template>
  <div class="warp">
    <el-tabs v-model="activeName">
      <el-tab-pane label="企业端注册协议" name="first">
        <div>
          <vue-ueditor-wrap v-model="companyXieyi" :config="config" class="ueditor" />
          <div class="button">
            <el-popconfirm title="确定更新注册协议吗？" @onConfirm="updateContents">
              <el-button slot="reference" :loading="loading" type="primary">更新注册协议</el-button>
            </el-popconfirm>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="企业端隐私政策" name="second">
        <div>
          <vue-ueditor-wrap v-model="companyYinsi" :config="config" class="ueditor" />
          <div class="button">
            <el-popconfirm title="确定更新隐私协议协议？" @onConfirm="updateContents">
              <el-button slot="reference" :loading="loading" type="primary">更新隐私协议</el-button>
            </el-popconfirm>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="关于我们" name="third">
        <div>
          <vue-ueditor-wrap v-model="aboutUs" :config="config" class="ueditor" />
          <div class="button">
            <el-popconfirm title="确定更新关于我们协议？" @onConfirm="updateContents">
              <el-button slot="reference" :loading="loading" type="primary">更新关于我们</el-button>
            </el-popconfirm>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="借支审批规则说明" name="four">
        <div>
          <vue-ueditor-wrap v-model="jiezhiContent" :config="config" class="ueditor" />
          <div class="button">
            <el-popconfirm title="确定更借支审批规则说明？" @onConfirm="updateContents">
              <el-button slot="reference" :loading="loading" type="primary">更新借支审批</el-button>
            </el-popconfirm>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import environment from '@/utils/environment'
export default {
  components: { VueUeditorWrap },
  data() {
    return {
      activeName: 'first', // 活动的标签栏
      companyXieyi: '', // 注册协议
      aboutUs: '', // 关于我们
      companyYinsi: '', // 隐私协议
      jiezhiContent: '',
      loading: false,
      config: {
        UEDITOR_HOME_URL: '/ueditor/', // 需要令此处的URL等于对应 ueditor.config.js 中的配置。
        autoHeightEnabled: false,
        initialFrameHeight: 450,
        initialFrameWidth: 400,
        maximumWords: 9999999,
        // initialFrameWidth:3000,
        zIndex: 3000,
        serverUrl: '',
        // serverUrl: `${process.env.VUE_APP_PROXY_URL}/service-admin/admin/file/ueditor/upload`,
        enableAutoSave: true // 开启从草稿箱恢复功能需要手动设置固定的 editorId，否则组件会默认随机一个，如果页面刷新，下次渲染的时候 editorId 会重新随机，导致无法加载草稿箱数据
        // BaseUrl: process.env.VUE_APP_BASE_URL,
      }
    }
  },
  mounted() {
    this.getContents()
    this.config.serverUrl = environment.richTextPath()
    // this.$refs.register.setContent()
  },
  methods: {
    updateContents() {
      var params = {
        aboutUs: this.aboutUs,
        companyXieyi: this.companyXieyi,
        companyYinsi: this.companyYinsi,
        jiezhiContent: this.jiezhiContent
      }
      this.loading = true
      this.$api.setting
        .reqUpdateContents(params)
        .then((res) => {
          this.$message.success(res)
          this.getContents()
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取注册协议信息
    getContents() {
      var loading = this.$loading({
        lock: true,
        text: '加载中....',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$api.setting
        .reqContents()
        .then((res) => {
          this.companyXieyi = res.companyXieyi
          this.aboutUs = res.aboutUs
          ;(this.companyYinsi = res.companyYinsi), (this.jiezhiContent = res.jiezhiContent)
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          loading.close()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  min-height: 100%;
}
.button {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
}
</style>
